<div class="expandir">
  <ng-container *ngIf="!endLoading">
    <app-loading-spinner></app-loading-spinner>
  </ng-container>
</div>
<div class="expandir" *ngIf="endLoading">
  <mat-toolbar class="mat-elevation-z8 mat-toolbar-background">
    <div class="logo-background">
      <button (click)="drawer.toggle()" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
      <span>
        <a href="/" title="Grupo Bimbo">
          <img
            width="80px"
            src="//bmbprov.s3.us-west-2.amazonaws.com/s3fs-public/2021-05/Grupo-Bimbo-Proveedores-Logotipo.png"
            data-src="//bmbprov.s3.us-west-2.amazonaws.com/s3fs-public/2021-05/Grupo-Bimbo-Proveedores-Logotipo.png"
            alt="Logo Grupo Bimbo" />
        </a>
      </span>
    </div>
    <br />
    <span class="example-spacer"></span>
    <div class="d-flex flex-row-reverse">
      <div class="userInfo card-body">
        <h2 class="card-title text-left m-0 d-flex flex-row-reverse">
          {{ userLogged.name }}
        </h2>
        <h4 class="card-text text-left m-0 d-flex flex-row-reverse">
          {{ roleName }} - #{{ userLogged.personNumber }}
        </h4>
      </div>
    </div>
  </mat-toolbar>
  <mat-drawer-container autosize>
    <mat-drawer #drawer opened="true" mode="side" position="start">
      <nav class="sidebar">
        <div class="menu-bar">
          <div class="menu">
            <ul class="menu-link">
              <ng-container *ngFor="let menuItem of menuItems">
                <ng-container *ngIf="isMenuItemAllowed(menuItem.allowedRoles)">
                  <hr *ngIf="menuItem.isNewSectionDivision" class="my-2" />
                  <li class="nav-link" [routerLinkActive]="'active'">
                    <a
                      [routerLink]="menuItem.routerLink"
                      *ngIf="!menuItem.subItems; else subMenuHead">
                      <mat-icon class="icon">{{ menuItem.icon }}</mat-icon>
                      <span class="text nav-text">{{ menuItem.text }}</span>
                    </a>
                    <ng-template #subMenuHead>
                      <div>
                        <a (click)="toggleSubMenu($event, menuItem)">
                          <mat-icon class="icon">{{ menuItem.icon }}</mat-icon>
                          <span class="text nav-text">{{ menuItem.text }}</span>
                          <mat-icon class="icon" *ngIf="!menuItem.expanded"
                            >keyboard_arrow_down</mat-icon
                          >
                          <mat-icon class="icon" *ngIf="menuItem.expanded"
                            >keyboard_arrow_up</mat-icon
                          >
                        </a>
                      </div>
                    </ng-template>
                  </li>
                </ng-container>
                <ng-container *ngIf="menuItem.expanded">
                  <ng-container *ngFor="let subItem of menuItem.subItems">
                    <li
                      class="nav-link"
                      [routerLinkActive]="'active'"
                      *ngIf="isMenuItemAllowed(subItem.allowedRoles)">
                      <a
                        [routerLink]="subItem.routerLink"
                        class="sub-menu-item">
                        <mat-icon class="icon">{{ subItem.icon }}</mat-icon>
                        <span class="text nav-text">{{ subItem.text }}</span>
                      </a>
                    </li>
                  </ng-container>
                </ng-container>
              </ng-container>
              <hr class="my-2" />
              <li class="nav-link">
                <a (click)="logout()">
                  <mat-icon class="icon">exit_to_app</mat-icon>
                  <span class="text nav-text">Cerrar sesión</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </mat-drawer>
    <mat-drawer-content>
      <div style="min-height: 750px">
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
